import { Reducer } from 'redux';
import { WidgetActionType } from '../actions';
import { WidgetSetComponentAction } from './actions';
import { Action } from 'store/store';

export function createComponentStateReducer<T>(
    initialState: T
): Reducer<T, WidgetSetComponentAction<T> | Action<unknown>> {
    return (
        state: T = initialState,
        action: WidgetSetComponentAction<T> | Action<unknown>
    ) => {
        if (!action.payload || !action.payload.componentDelta) {
            return state;
        }

        if (action.type === WidgetActionType.WIDGET_SET_COMPONENT_STATE) {
            return { ...state, ...action.payload!.componentDelta };
        }
        return state;
    };
}
